import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientOriginsComponent } from './client-origins.component';
import { ClientOriginsDesktopComponent } from './desktop/client-origins.desktop.component';
import { ClientOriginsMobileComponent } from './mobile/client-origins.mobile.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ClientOriginsController } from './client-origins.controller';
import { TranslationModule } from '@app/app-translation.module';
import { ClientOriginComponentModule } from '../client-origin-component/client-origin.component.module';
import { TableDesktopModule } from '@beego/ngx-table';
import { AppModule } from '@app/app.module';
import { StateManager } from '@shared-managers/state.manager';
import { TranslateService } from '@ngx-translate/core';
import { PipesModule } from '@shared-pipes/pipes.module';
import { DirectivesModule } from '@shared-directives/directives.module';

@NgModule({
	declarations: [ClientOriginsDesktopComponent, ClientOriginsMobileComponent, ClientOriginsComponent],
	exports: [ClientOriginsComponent],
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		PipesModule,
		DirectivesModule,
		TranslationModule,
		TableDesktopModule.forRoot(AppModule.injector.get(StateManager), AppModule.injector.get(TranslateService)),
		ClientOriginComponentModule,
	],
	providers: [ClientOriginsController],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClientOriginsComponentModule {}
